import React from 'react';
import { Filter, DateInput, SelectInput, Datagrid, TextField, DateField, FunctionField } from 'react-admin';
import TList from '../../components/wrapper/TList';
import AmountField from '../../components/fields/AmountField';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';

const itemTypesForSelection = [
	'Account Opening',
	'Account Closing',
	'Invoice',
	'Payment',
	'Manual Payment',
	'Payment Chargeback',
	'P2P',
	'Purchase',
	'Refund',
	'Credit',
	'Settlement',
	'Trade',
	'Deposit'
].map(key => {
	return { id: key, name: key };
});

const itemSubTypesForSelection = ['Incoming', 'Outgoing'].map(key => {
	return { id: key, name: key };
});

const itemStatusForSelection = [
	'Created',
	'InProgress',
	'Completed',
	'Cancelled',
	'Expired',
	'Failed',
	'Locked',
	'Released',
	'Declined'
].map(key => {
	return { id: key, name: key };
});

const WalletAccountItemFilter = props => (
	<Filter {...props}>
		<DateInput
			alwaysOn
			source="fromDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<DateInput
			alwaysOn
			source="untilDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<SelectInput alwaysOn="true" source="itemType" choices={itemTypesForSelection} />
		<SelectInput alwaysOn="true" source="itemSubType" choices={itemSubTypesForSelection} />
		<SelectInput alwaysOn="true" source="itemStatus" choices={itemStatusForSelection} />
	</Filter>
);

const WalletAccountItemList = props => (
	<TList
		{...props}
		filters={<WalletAccountItemFilter />}
		sort={{ field: 'creationDateTime', order: 'DESC' }}
	>
		<Datagrid rowClick="show">
			<DateField source="creationDateTime" showTime />
			<FunctionField
				source="transactionOwner"
				sortable={false}
				render={item => `${item.transactionOwner.type} - ${item.transactionOwner.id}`}
			/>
			<TextField source="itemType" />
			<TextField source="itemSubType" sortable={false} />
			<TextField source="itemStatus" />
			<AmountField source="amount" />
		</Datagrid>
	</TList>
);

export default WalletAccountItemList;
